// sessionManager.js
import config from '@config';
import secureStore from '@utils/secureStore';
import { AppState } from 'react-native';

const SESSION_ID_KEY = 'SESSION_ID';
const LAST_ACTIVITY_KEY = 'LAST_ACTIVITY_TIMESTAMP';
const SESSION_TIMEOUT = Number(config.SESSION_TIMEOUT_MS) || 90_000; // 90 seconds fallback

let sessionId = null;
let lastActivity = null;
let initialized = false;

function generateUUIDv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8; // v = 4 for version, y = variant
    return v.toString(16);
  });
}

function generateNewSessionId() {
  const newId = generateUUIDv4();
  secureStore.setItemAsync(SESSION_ID_KEY, newId);
  return newId;
}

const sessionManager = {
  async init() {
    const storedSession = await secureStore.getItemAsync(SESSION_ID_KEY);
    const storedLastActivity = await secureStore.getItemAsync(LAST_ACTIVITY_KEY);

    sessionId = storedSession || generateNewSessionId();

    lastActivity = storedLastActivity ? parseInt(storedLastActivity, 10) : Date.now();

    initialized = true;

    // eslint-disable-next-line no-use-before-define
    AppState.addEventListener('change', handleAppStateChange);
  },

  getSessionId() {
    if (!initialized) this.init();
    this.checkExpiry();
    return sessionId;
  },

  updateActivity() {
    lastActivity = Date.now();
    secureStore.setItemAsync(LAST_ACTIVITY_KEY, lastActivity.toString());
  },

  resetSession() {
    sessionId = generateNewSessionId();
    lastActivity = Date.now();
    secureStore.setItemAsync(SESSION_ID_KEY, sessionId);
    secureStore.setItemAsync(LAST_ACTIVITY_KEY, lastActivity.toString());
  },

  clear() {
    sessionId = null;
    lastActivity = null;
    secureStore.remoteItemAsync(SESSION_ID_KEY);
    secureStore.remoteItemAsync(LAST_ACTIVITY_KEY);
  },

  checkExpiry() {
    const now = Date.now();
    if (now - lastActivity > SESSION_TIMEOUT) {
      this.resetSession();
    } else {
      this.updateActivity();
    }
  },
};
function handleAppStateChange(nextState) {
  if (nextState === 'active') {
    sessionManager.checkExpiry();
  }
}

export default sessionManager;
